'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  // mainpage deteiled search
  $('#buy .search__more').on('click', function () {
    if (window.innerWidth > 1023) {
      $('#buy .search-details').slideToggle(500);
      $('#buy .search-form .search-form__button').toggleClass('non-active');
      $('#buy .search-form__hide').toggleClass('active');
      $(this).toggleClass('active');
    } else {
      $('#buy .search-details').slideToggle(500);
      $(this).toggleClass('active');
    }
  });
  $('#buy .search-form__hide').on('click', function () {
    $('#buy .search-details').slideUp(500);
    $('#buy .search-form .search-form__button').removeClass('non-active');
    $(this).removeClass('active');
    $('#buy .search__more').toggleClass('active');
  });

  $('#charter .search__more').on('click', function () {
    if (window.innerWidth > 1023) {
      $('#charter .search-details').slideToggle(500);
      $('#charter .search-form .search-form__button').toggleClass('non-active');
      $('#charter .search-form__hide').toggleClass('active');
      $(this).toggleClass('active');
    } else {
      $('#charter .search-details').slideToggle(500);
      $(this).toggleClass('active');
    }
  });
  $('#charter .search-form__hide').on('click', function () {
    $('#charter .search-details').slideUp(500);
    $('#charter .search-form .search-form__button').removeClass('non-active');
    $(this).removeClass('active');
    $('#charter .search__more').toggleClass('active');
  });

  // catalog sidebar
  if (window.innerWidth > 1024) {
    $('.sidebar').stick_in_parent({
      offset_top: 20
    }).on("sticky_kit:stick", function (e) {
      if (window.navigator.msPointerEnabled) {
        jcf.destroy($('.sidebar select'));
        jcf.replace($('.sidebar select'));
      }
    });
  }

  if (window.innerWidth < 768) {
    $('.advantage__text').mCustomScrollbar();
    $('.product-inside__text').mCustomScrollbar();
  }

  // fixed manager
  $('.fixed-contact__small').on('click', function () {
    $('.fixed-contact__drop').slideToggle(500);
    $(this).toggleClass('active');
  });
  $('.fixed-contact__close').on('click', function () {
    $('.fixed-contact__drop').slideUp(500);
    $('.fixed-contact__small').removeClass('active');
  });

  // crew popup
  $('.crew__hire').on('click', function () {
    $('.crew-popup').slideDown(500);
  });
  $('.crew-popup__close').on('click', function () {
    $('.crew-popup').slideUp(500);
  });
  if (window.innerWidth < 1280) {
    $('.crew__hire').on('click', function () {
      $('body, html').css('overflow', 'hidden');
    });
    $('.crew-popup__close').on('click', function () {
      $('body, html').css('overflow', '');
    });
  }

  $(window).scroll(function () {
    jcf.replace();
  });
};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/components/animations.js
// module id = 4
// module chunks = 0